"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    fields: {
      messages: {
        hideNotesConfirm: 'Möchten Sie die Notiz wirklich verstecken? Sie werden den Inhalt verlieren.'
      },
      actions: {
        addNote: 'Notiz hinzufügen',
        removeNote: 'Notiz entfernen',
        unlock: 'Freischalten'
      }
    }
  }
};
var _default = messages;
exports.default = _default;